export default __webpack_public_path__ + "ce6c19f470d1b79386f8f64870d2b2e7.svg";